import React from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import Layouts from '../layouts/Layouts';
import { PlaylistAddCheckCircle, PlaylistAddCircle } from '@mui/icons-material';

const Bidang = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Layouts>
            <div>
                <h1>MASTER BIDANG</h1>
            </div>

            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/bidang/form`} className={` sub-menu-item ${split[3] === 'form'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle />
                                        </div>
                                        <span>Input Bidang</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/bidang/data`} className={` sub-menu-item ${split[3] === 'data'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Data Bidang</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
                
            { children }
        </Layouts>
    )
}

export default Bidang
